import {IFasterqState} from "../../interfaces/fasterq-interfaces";
import {FasterqLineModel} from "../../models/fasterq-line-model";
import {List} from "immutable";

export const initialFasterqState: IFasterqState = {
    lines: List(),
    queues: List(),
    analytics: List(),
    terminal: new FasterqLineModel({})
};
